import React from 'react';
import './Services.css'; // Updated CSS file
import screeningImg from './assets/screening.jpg';
import diagnosticsImg from './assets/diagnostics.jpg';
import managementImg from './assets/management.jpg';
import followupImg from './assets/followup.jpg';
import counsellingImg from './assets/counselling.jpg';
import trainingImg from './assets/training.jpg';

const services = [
  {
    title: 'Diabetes & Hypertension Screening',
    description: 'We focus on early identification of individuals at risk, enabling timely intervention and prevention of long-term complications.',
    image: screeningImg,
    activities: [
      'Blood pressure checks',
      'Blood sugar (glucose) testing',
      'BMI & lifestyle risk assessments',
      'Family history evaluations',
      'Community health outreach screenings',
    ],
  },
  {
    title: 'Diagnostics & Laboratory Services',
    description: 'Our well-equipped laboratory provides accurate and efficient testing to support clinical diagnosis and care decisions.',
    image: diagnosticsImg,
    activities: [
      'Full blood count (FBC)',
      'Lipid profile testing',
      'HbA1c (long-term sugar control)',
      'Urinalysis and kidney function tests',
      'Sample processing and result reporting',
    ],
  },
  {
    title: 'Diabetes & Hypertension Management',
    description: 'We provide personalized care plans for managing chronic conditions with a focus on education, medication, and lifestyle.',
    image: managementImg,
    activities: [
      'Medication review & adjustment',
      'Dietary counseling',
      'Blood pressure and glucose monitoring',
      'Routine medical check-ups',
      'Individual care plan creation',
    ],
  },
  {
    title: 'Chronic Disease Follow-up & Monitoring',
    description: 'Our structured follow-up program ensures continuous care and monitoring for patients with chronic diseases.',
    image: followupImg,
    activities: [
      'Scheduled follow-up appointments',
      'Remote health check-ins',
      'Compliance and adherence tracking',
      'Monitoring disease progression',
      'Patient data reviews and updates',
    ],
  },
  {
    title: 'Counselling',
    description: 'We offer a safe and supportive space for patients to address mental, emotional, and behavioral challenges.',
    image: counsellingImg,
    activities: [
      'One-on-one counseling sessions',
      'Group therapy support',
      'Stress and anxiety management',
      'Lifestyle and behavioral guidance',
      'Psychoeducation on chronic illnesses',
    ],
  },
  {
    title: 'Trainings',
    description: 'We empower patients, caregivers, and healthcare workers through targeted educational programs and workshops.',
    image: trainingImg,
    activities: [
      'Patient education on self-care',
      'Family caregiver workshops',
      'Community health education',
      'Staff continuing medical training',
      'Health promotion seminars',
    ],
  },
];

const OurServicesPage = () => {
  return (
    <div className="services-page-container">
      <h2 className="services-page-heading">Our Services</h2>
      <p className="services-page-subtext">
        Explore the full range of health services offered at Mwangaza Wellness and Medical Centre,
        designed to deliver compassionate, professional, and holistic care to every patient.
      </p>

      <div className="services-cards-wrapper">
        {services.map((service, index) => (
          <div key={index} className="services-card">
            <img src={service.image} alt={service.title} className="services-card-image" />
            <div className="services-card-body">
              <h3 className="services-card-title">{service.title}</h3>
              <p className="services-card-description">{service.description}</p>
              <h4 className="services-card-activity-header">Activities under this service:</h4>
              <ul className="services-card-activity-list">
                {service.activities.map((activity, i) => (
                  <li key={i}>{activity}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurServicesPage;
